import { render, staticRenderFns } from "./BackgroundSearchView.vue?vue&type=template&id=13d7ae48&scoped=true&"
import script from "./BackgroundSearchView.vue?vue&type=script&lang=js&"
export * from "./BackgroundSearchView.vue?vue&type=script&lang=js&"
import style0 from "./BackgroundSearchView.vue?vue&type=style&index=0&id=13d7ae48&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13d7ae48",
  null
  
)

export default component.exports